import { useTranslation } from 'react-i18next';
import { OnboardingSpotlight } from './OnboardingSpotlight';

interface SidebarTourStepProps {
    onNext: () => void;
}

export const SidebarTourStep = ({ onNext }: SidebarTourStepProps) => {
    const { t } = useTranslation();
    return (
        <OnboardingSpotlight
            targetSelector='[data-onboarding="sidebar-toggle"]'
            title={t('chat.onboarding.sidebar.title')}
            description={t('chat.onboarding.sidebar.description')}
            buttonText={t('chat.onboarding.sidebar.button')}
            onNext={onNext}
        />
    );
};
